import { AssetProviderUid } from '@gelato-api-ui/core/designs/asset-provider-uid.enum';
import { PrintAreaName } from '@gelato-api-ui/core/print-areas/constants/print-area-name';
import { Dimensions } from '@product-catalogue/src/lib/product-catalogue/lib/dimentions';

export interface PriceBreakdownItem {
  price: string;
  imageUrl?: string;
  iconUrl?: ItemIconUrl;
  name: PriceBreakdownPrintAreaNameType;
}

export interface PriceBreakdownApiRequest {
  productUid: string;
  productTypeUid: string;
  designId: string;
  printAreas: string[];
  country: string;
  currency: string;
  pageCount: number;
  clientId: string;
  trigger: number;
  dimensions: Dimensions;
}

export interface PriceBreakdownApiResponse {
  priceBreakdown: PriceBreakdownData;
}

export interface PriceBreakdownData {
  total: string;
  productTotal: string;
  designTotal: string;
  includedPrintArea: PrintAreaName;
  designBreakdown: DesignPriceBreakdownItem[];
  breakdown: PriceBreakdown;
}

export interface DesignPriceBreakdownItem {
  imageId: string;
  title: string;
  price: string;
  comment: string;
  imageUrl?: string;
  assetProviderUid: AssetProviderUid;
}

export enum PriceBreakdownPrintAreaNameEnum {
  Product = 'product',
}

export type PriceBreakdownPrintAreaNameType = PriceBreakdownPrintAreaNameEnum | PrintAreaName;

export interface PriceBreakdown {
  [PriceBreakdownPrintAreaNameEnum.Product]: string;
  [PrintAreaName.Front]: string;
  [PrintAreaName.Back]: string;
  [PrintAreaName.SleeveLeft]?: string;
  [PrintAreaName.SleeveRight]?: string;
  [PrintAreaName.NeckInner]?: string;
  [PrintAreaName.NeckOuter]?: string;
}

export enum ItemIconUrl {
  Collection = 'icons/collections.svg',
  PrintSide = 'icons/brush.svg',
  Product = 'icons/products-black.svg',
}
